interface Trailer {
  _id: string;
  title: string;
  videoUrl: string;
  platform: string;
  isMainTrailer: boolean;
}

export function getMainTrailer(trailers?: Trailer[]): Trailer | undefined {
  if (!trailers?.length) return undefined;

  // First try to find the main trailer
  const mainTrailer = trailers.find(t => t.isMainTrailer);
  if (mainTrailer) return mainTrailer;

  // If no main trailer, get the first one in the list (which is sorted by release date)
  return trailers[0];
}